import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
const LIST_AUTOMATION_RUNS_PATH = '/rest/automations/{automation_id}/runs';
export function getListAutomationRunsQueryKey(automationId) {
    return QueryClientHelper.makeQueryKey(LIST_AUTOMATION_RUNS_PATH, automationId);
}
//# sourceMappingURL=useListAutomationRuns.js.map